import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ReportViewer() {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state || !state.pdfUrl) {
    return (
      <div>
        <p>No PDF to display</p>
        <button onClick={() => navigate("/admin/dashboard")}>← Back</button>
      </div>
    );
  }

  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src={state.pdfUrl}
        title="PDF Report"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
}
